module.exports = "\nprecision mediump float;\n\nvarying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float alpha;\n\n\nvec4 Desaturate(vec4 texture, float Desaturation)\n{\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 color = texture.rgb;\n  vec3 gray = vec3(dot(grayXfer, color));\n  return vec4(mix(color, gray, Desaturation), texture.a);\n}\n\nvoid main(void)\n{\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 desaturateVec = Desaturate(original, 1.0 - alpha);\n\n    gl_FragColor = vec4(desaturateVec*alpha);\n    // gl_FragColor = vec4(Desaturate(original*alpha, 1.0));\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/glsl/opacify/opacify_fs.glsl
 ** module id = 726
 ** module chunks = 2
 **/